import React from 'react';
import { Button } from './Button';
export const CTASection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/6oqdjPAT?coupon_code=7DAYRESETSPECIAL2025';
  return <section className="bg-gradient-to-b from-teal-700 to-teal-900 text-white py-16" data-id="element-93">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-94">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-95">
          Start Healing Now
        </h2>
        <div className="mb-10 max-w-3xl mx-auto" data-id="element-96">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nUeLAzzv45miakpemeQKce/Mockups_-_21_Day_Program_2.png" alt="Neurotoned program materials including journal and guides" className="w-full rounded-lg shadow-xl mb-8" data-id="element-97" />
        </div>
        <div className="text-center mb-10 space-y-4" data-id="element-98">
          <p className="text-lg" data-id="element-99">You already know this work matters.</p>
          <p className="text-lg" data-id="element-100">
            Let Neurotoned help you finally <em data-id="element-101">live</em> it.
          </p>
          <p className="text-xl font-bold mt-6" data-id="element-102">
            One-time payment: normally $49 — today just $9
          </p>
          <p className="text-lg" data-id="element-103">
            Lifetime access. Therapist-led. Start today.
          </p>
          <p className="text-lg font-bold italic text-red-300 mt-4" data-id="element-104">
            This special $9 Founder's Rate is only available for a limited time.
            It will return to $49 once this cohort closes.
          </p>
        </div>
        <p className="text-center text-lg mb-6" data-id="element-105">
          Already Know The Science? Now You'll Feel the Shift — With Just One
          Week of Daily Body-Based Practice.
        </p>
        <div className="flex justify-center" data-id="element-106">
          <Button link={checkoutUrl} data-id="element-107">Try the 7-Day Reset – Just $9 ➔</Button>
        </div>
      </div>
    </section>;
};